import { render, staticRenderFns } from "./DinventoryBinCard.vue?vue&type=template&id=0bb1d19a&scoped=true"
import script from "./DinventoryBinCard.vue?vue&type=script&lang=js"
export * from "./DinventoryBinCard.vue?vue&type=script&lang=js"
import style0 from "./DinventoryBinCard.vue?vue&type=style&index=0&id=0bb1d19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb1d19a",
  null
  
)

export default component.exports